import CLabel from '@/components/main/CLabel';
import { Degree, Description, DownLoadCV, Globe, PostJob } from '@/components/Svg';
import { useAuthContext } from '@/context/AuthContext';
import { ActionIcon, Card, Grid, createStyles } from '@mantine/core';
import Image from 'next/image';
import Link from 'next/link';
import { useDispatch } from 'react-redux';

const useStyles = createStyles((theme) => ({
  label: {
    fontSize: '12px',
  },
  favButton: {
    height: '32px',
    width: '32px',
    padding: '8px 10px',
  },
  appButton: {
    height: '32px',
    width: '62px',
    padding: '8px 10px',
  },
  title: {
    fontSize: '20px',
    lineHeight: '28px',
  },
  timer: {
    fontSize: '40px',
  },
  para: {
    color: '#A4A4A4',
    fontSize: '14px',
    lineHeight: '24px',
  },
  avatar: {
    height: '60px',
    width: '60px',
    borderRadius: '50%',
  },
  comName: {
    fontSize: '18px',
    lineHeight: '28px',
    color: '#777777',
  },
}));

export default function ExpertSmallCard({ dictionary, expert, ...props }) {
  const { classes } = useStyles();
  const { user, userDocument } = useAuthContext();
  const dispatch = useDispatch();

  const onDownloadCV = () => {
    dispatch({
      type: 'cvModal/setCVModalData',
      payload: { data: expert },
    });
    dispatch({ type: 'cvModal/toggleCVModal' });
  };

  return (
    <Card padding={'lg'} style={{ borderRadius: '12px' }} withBorder {...props}>
      <Grid align="center">
        <Grid.Col span={12}>
          <div className="flex flex-col">
            <div className="flex items-center justify-between">
              <div className="flex flex-wrap ">
                {expert?.sectors?.map((sector, index) => (
                  <CLabel
                    key={index}
                    text={sector}
                    className={`${classes.label} me-[8px] mt-1 sm:mt-0 text-xs`}
                  />
                ))}
              </div>
              {userDocument?.role == 'organization' || userDocument?.role == 'admin' ? (
                <ActionIcon
                  aria-label={dictionary.downloadCV}
                  onClick={onDownloadCV}
                  variant="gradient"
                  size={28}
                  mt={2}
                >
                  <DownLoadCV height="18px" width="18px" />
                </ActionIcon>
              ) : (
                <Link
                  href={`/experts/${expert.slug ? expert.slug : expert.id}`}
                  className="no-underline "
                >
                  <ActionIcon
                    size={'lg'}
                    variant="gradient"
                    aria-label={dictionary.details}
                    title={dictionary.details}
                  >
                    <Description />
                  </ActionIcon>
                </Link>
              )}
            </div>
            <div className="flex flex-col mt-[15px]">
              <div className="flex">
                <div className="flex items-center w-full text-primary">
                  <Degree height="16" width="16" />
                  <p className={`${classes.para} ms-[10px] m-0 text-[12px]`}>
                    {expert.highestDegree}
                  </p>
                </div>
                <div className="flex items-center w-full text-primary">
                  <PostJob height="16" width="16" />
                  <p className={`${classes.para} ms-[10px] m-0 text-[12px]`}>
                    {expert?.yearsOfExperience ?? 0} {dictionary.years}
                  </p>
                </div>
              </div>

              <div className="flex items-center text-primary">
                <Globe width="14" height="19" />
                <p className="text-textGrey ml-2 text-[14px] my-0 whitespace-nowrap">
                  {expert?.citizenships.toString()}
                </p>
              </div>
            </div>
            <div className="flex items-center mt-[15px]">
              <Link href={`experts/${expert.id}`}>
                <Image
                  height={50}
                  width={50}
                  
                  src={expert.photoURL ?? '/images/user.svg'}
                  className={`${classes.avatar} rounded-full`}
                  alt={expert.name}
                />
              </Link>
              <div className="flex flex-col ms-[12px]">
                <Link href={`experts/${expert.id}`} className="no-underline ">
                  <h4
                    className={`${classes.comName} p-0 hover:text-primary whitespace-nowrap m-0 transition-all duration-200`}
                  >
                    {expert.name}
                  </h4>
                </Link>
                <p className={`${classes.para}  m-0`}>{expert.position}</p>
              </div>
            </div>
          </div>
        </Grid.Col>
      </Grid>
    </Card>
  );
}
